import PropTypes from 'prop-types';
import { createContext, useCallback, useMemo, useState } from 'react';

export const DataGridStateContext = createContext(null);

const DataGridStateContextProvider = ({ children }) => {
  const [state, setState] = useState({});

  const setGridState = useCallback((key, payload) => {
    if (!key) {
      return;
    }

    setState(prevState => ({
      ...prevState,
      [key]: payload,
    }));
  }, []);

  const clearGridState = useCallback(key => {
    if (!key) {
      return;
    }

    setState(prevState => {
      if (!Object.hasOwn(prevState, key)) {
        return prevState;
      }

      const { [key]: _, ...nextState } = prevState;
      return nextState;
    });
  }, []);

  const value = useMemo(
    () => ({
      getGridState: key => state[key],
      setGridState,
      clearGridState,
    }),
    [clearGridState, setGridState, state]
  );

  return (
    <DataGridStateContext.Provider value={value}>
      {children}
    </DataGridStateContext.Provider>
  );
};

DataGridStateContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DataGridStateContextProvider;
